import { createFileRoute } from '@tanstack/react-router';

import ComingSoonCover from '@/components/ComingSoonCover';

export const Route = createFileRoute('/_staff/people/_list/people-graph')({
  component: () => <ComingSoonCover />,
});
